import React, { useEffect, useState } from 'react';
import { Typography, CircularProgress, Menu, MenuItem, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Drawer, TextField, Button, InputAdornment, IconButton } from '@mui/material';
import '../Css/DriverTable.css';
import '../Css/StaffMgmt.css';
import Box from '@mui/material/Box';
import { Tooltip } from 'react-tooltip';
import Fade from '@mui/material/Fade';
import { IoCreateOutline } from "react-icons/io5";
import Backdrop from '@mui/material/Backdrop';
import Modal from "@material-ui/core/Modal";
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { FaEdit, FaTrashAlt, FaEye } from 'react-icons/fa';
import Navbar from '../Component/Navbar';
import Logger from './Logger';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { FaListUl } from "react-icons/fa";
import { connectSocket } from '../utils/connectSocket';
import { getLoggerBaseURL } from '../utils/getLoggerBaseURL';

// Initialize Logger
const logger = new Logger(getLoggerBaseURL());

const Dispatcher = () => {
  const userEmail = sessionStorage.getItem('userEmail');
  const [dispatchers, setDispatchers] = useState([]);
  const [activeTab, setActiveTab] = useState('driverList');
  const [selectedDriver, setSelectedDriver] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedDispatcherId, setSelectedDriverId] = useState(null);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [otp, setOtp] = useState('');

  const [newDispatcherDetails, setNewDispatcherDetails] = useState({
    name: '',
    phone: '',
    email: '',
    password: '',
    notes: '',
    adminEmail: userEmail
  });
  const [open, setOpen] = React.useState(false);
  const [view, setView] = React.useState(false);
  const [search, setSearch] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editDispatcherDetails, setEditDriverDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [successSnackbarOpen, setSuccessSnackbarOpen] = useState(false);
  const [successSnackbarMessage, setSuccessSnackbarMessage] = useState('');

  // Initialize the socket
  useEffect(() => {
    const socket = connectSocket();

    // Listen for driver status updates
    socket.on('driverStatusUpdated', (updatedDriver) => {
      logger.log(`Updated dispatchers state: ${updatedDriver}`, 'INFO');
      logger.log(`Updated dispatchers Id: ${updatedDriver.id}`, 'INFO');
      setDispatchers((prevDrivers) => prevDrivers.map(driver =>
        driver._id === updatedDriver.id ? { ...driver, status: updatedDriver.status } : driver
      ));

    });

    return () => {
      socket.disconnect();
    };
  }, []);


  useEffect(() => {
    logger.log(`Drivers state updated ${dispatchers}`, 'INFO');
  }, [dispatchers]); // Dependency array ensures this runs whenever dispatchers state changes

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '1px solid lightgray',
    borderRadius: 2,
    boxShadow: 24,
    p: 4,
  };

  const sstyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    bgcolor: 'background.paper',
    border: '1px solid lightgray',
    borderRadius: 2,
    boxShadow: 24,
    p: 4,
    padding: '16px'
  };

  const circularStyle = {
    width: 60,
    height: 60,
    borderRadius: '50%',
    backgroundColor: ' #79c6e9',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '24px',
    marginLeft: '45%',
  };

  const handleViewClick = (driverId) => {
    const driver = dispatchers.find((d) => d._id === driverId);
    if (driver) {
      setSelectedDriver(driver);
      setSelectedDriverId(driverId);
      setView(true);
    }
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleResetForm = () => {
    setNewDispatcherDetails({
      name: '',
      phone: '',
      email: '',
      otp: '',
      password: '',
      notes: '',
      adminEmail: userEmail
    });
    setIsOtpVerified(false);
    setIsOtpSent(false);
    setOtp('');
    setIsSendingOtp(false);
    setIsVerifyingOtp(false);
  }

  const handleTogglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
    setSuccessSnackbarOpen(false);
  };

  const handleview = async () => {
    if (selectedDispatcherId) {
      try {
        const adminEmail = sessionStorage.getItem('userEmail');
        const response = await fetch(`/api/dispatcher/${selectedDispatcherId}/${adminEmail}`);
        if (!response.ok) {
          throw new Error('Failed to fetch driver details');
        }

        const driver = await response.json();
        setSelectedDriver(driver);
        setView(true);
      } catch (error) {
        logger.log(`Error fetching driver details: ${error.message}`, 'ERROR');
      }
    }
  };

  const handlehide = () => {
    setView(false);
  };

  const fetchDispatchers = async () => {
    const adminEmail = sessionStorage.getItem('userEmail');

    if (!adminEmail) {
      logger.log('No admin email found in session', 'ERROR');
      setLoading(false); // Set loading to false if no admin email
      return;
    }

    try {
      const response = await fetch(`/api/dispatcher/getAll/${adminEmail}`);
      if (!response.ok) {
        logger.log('No admin email found in session', 'ERROR');
        setLoading(false); // Set loading to false if no admin email
        return;
      }
      const data = await response.json();
      if (data === null || data.length === 0) {
        setDispatchers([]); // Set dispatchers to an empty array if no data
      } else {
        setDispatchers(data);
      }
    } catch (error) {
      logger.log(`Error fetching dispatchers: ${error.message}`, 'ERROR');
      setDispatchers([]);
    }
    finally {
      setLoading(false); // Ensure loading state is updated even on error
    }
  };

  const handleDrawerClose = () => setIsDrawerOpen(false);

  const handleThreeDotsClick = (event, driverId) => {
    setAnchorEl(event.currentTarget);
    setSelectedDriverId(driverId);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleOpenDeleteDialog = () => {
    setIsDeleteDialogOpen(true);
  };

  const handleCloseDeleteDialog = () => {
    setIsDeleteDialogOpen(false);
  };

  const handleDeleteDispatcher = async () => {
    if (!selectedDispatcherId) return;

    try {

      const adminEmail = sessionStorage.getItem('adminEmail');
      const response = await fetch(`/api/dispatcher/delete/${selectedDispatcherId}/${adminEmail}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        throw new Error('Failed to delete driver');
      }

      setDispatchers((prevDrivers) => prevDrivers.filter((driver) => driver._id !== selectedDispatcherId));
      sessionStorage.removeItem('dispatchers');
      setIsDeleteDialogOpen(false);
      setAnchorEl(null);
    } catch (error) {
      logger.log(`Error deleting driver: ${error.message}`, 'ERROR');
    }
  };

  const handleInputChange = (field, value) => {
    // Allow only digits in the phone number field
    if (field === 'phone') {
      value = value.replace(/\D/g, ''); // Remove any non-digit characters

      // Limit the input to 10 digits
      if (value.length > 10) {
        value = value.slice(0, 10);
      }
    }

    setNewDispatcherDetails((prevDetails) => ({
      ...prevDetails,
      [field]: value,
    }));
  };

  const handleSaveDispatcher = async () => {
    const requiredFields = ['name', 'phone', 'email', 'password'];
    const missingFields = requiredFields.filter((field) => !newDispatcherDetails[field]);

    if (missingFields.length > 0) {
      setSnackbarMessage(`Please fill out the following fields: ${missingFields.join(', ')}`);
      setSnackbarOpen(true);
      return;
    }

    // Validate that name contains only alphabets and spaces
    const nameRegex = /^[A-Za-z\s]+$/;
    if (!nameRegex.test(newDispatcherDetails.name)) {
      setSnackbarMessage('Name should contain only alphabets.');
      setSnackbarOpen(true);
      return;
    }

    const adminEmail = sessionStorage.getItem('adminEmail');

    if (!adminEmail) {
      setSnackbarMessage('Admin email not found. Please log in again.');
      setSnackbarOpen(true);
      return;
    }

    if (newDispatcherDetails.phone.length !== 10) {
      setSnackbarMessage('Enter a 10-digit phone number');
      setSnackbarOpen(true);
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(newDispatcherDetails.email)) {
      setSnackbarMessage('Enter a valid email address');
      setSnackbarOpen(true);
      return;
    }

    try {
      const response = await fetch(`/api/dispatcher/dispatcher/${adminEmail}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(newDispatcherDetails),
      });

      if (!response.ok) {
        const errorText = await response.json();
        setSnackbarMessage(errorText.message);
        setSnackbarOpen(true);
        if (errorText.code === "PLAN_LIMIT" || errorText.code === "FEATURE_LOCKED" || errorText.code === "USAGE_BLOCKED") {
          window.dispatchEvent(new CustomEvent("zordigo-plan-limit", { detail: errorText }));
        }
        throw new Error(errorText.message || `Failed to create a new dispatcher`);
      }

      const createdDispatcher = await response.json();
      setDispatchers((prevDrivers) => [...prevDrivers, createdDispatcher]);
      sessionStorage.removeItem('dispatchers');

      setNewDispatcherDetails({
        name: '',
        phone: '',
        email: '',
        password: '',
        notes: '',
        adminEmail: userEmail
      });

      handleClose();
      handleDrawerClose();
      window.location.reload();
    } catch (error) {
      logger.log(`Error creating dispatcher: ${error.message}`, 'ERROR');
    }
  };

  useEffect(() => {
    fetchDispatchers();
  }, []);


  const handleEdit = (driverId) => {
    const driver = dispatchers.find((d) => d._id === driverId);
    if (driver) {
      setEditDriverDetails(driver);
      setIsEditModalOpen(true);
    } else {
      logger.log("Driver not found", 'ERROR');
    }
  };
  const handleEditInputChange = (field, value) => {
    setEditDriverDetails((prevDetails) => ({
      ...prevDetails,
      [field]: value,
    }));
  };

  const handleSaveEdit = async () => {
    if (!editDispatcherDetails) return;
    const nameRegex = /^[A-Za-z\s]+$/;
    if (!nameRegex.test(editDispatcherDetails.name)) {
      setSnackbarMessage('Name should contain only alphabets.');
      setSnackbarOpen(true);
      return;
    }
    try {


      const adminEmail = sessionStorage.getItem('adminEmail');
      const response = await fetch(`/api/dispatcher/update/${editDispatcherDetails._id}/${adminEmail}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(editDispatcherDetails),
      });

      if (!response.ok) {
        const errorText = await response.json();
        throw new Error(`Failed to update driver: ${errorText}`);
      }

      const updatedDriver = await response.json();
      setDispatchers((prevDrivers) =>
        prevDrivers.map((driver) =>
          driver._id === updatedDriver._id ? updatedDriver : driver
        )
      );

      sessionStorage.removeItem('dispatchers');

      setIsEditModalOpen(false);
    } catch (error) {
      logger.log(`Error updating driver: ${error.message}`, 'ERROR');
    }
  };

  const handleSendAndStoreOTP = async () => {
    if (!newDispatcherDetails.email) {
      setSnackbarMessage('Please enter email');
      setSnackbarOpen(true);
      return;
    }
    setIsSendingOtp(true);

    try {
      const adminEmail = sessionStorage.getItem('adminEmail');
      const response = await fetch(`/api/dispatcher/send-email/${newDispatcherDetails.email}/${adminEmail}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userEmail: newDispatcherDetails.email
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        setSnackbarMessage('Error sending OTP. Please check if you have entered a valid email and try again.');
        setSnackbarOpen(true);
        throw new Error(errorData.message || 'Error sending OTP. Please check if you have entered a valid email and try again.');
      }

      const responseData = await response.json();
      logger.log(`OTP sent for registration! ${responseData}`, 'INFO');
      setSnackbarMessage('OTP sent successfully to your email');
      setSnackbarOpen(true);
      setSuccessSnackbarMessage('OTP sent to your email. Please check your inbox.');
      setSuccessSnackbarOpen(true);
      setIsOtpSent(true);
    } catch (error) {
      logger.log(`OTP not sent: ${error.message}`, 'ERROR');
      setSnackbarMessage(`OTP not sent: ${error.message}`);
      setSnackbarOpen(true);
    } finally {
      setIsSendingOtp(false);
    }
  };

  const handleVerifyOTP = async () => {
    if (!otp) {
      setSnackbarMessage('Please enter OTP');
      setSnackbarOpen(true);
      return;
    }
    setIsVerifyingOtp(true);

    try {
      const adminEmail = sessionStorage.getItem('adminEmail');
      const response = await fetch(`/api/dispatcher/verify-otp/${newDispatcherDetails.email}/${adminEmail}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userEmail: newDispatcherDetails.email,
          otp,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        setSnackbarMessage('Invalid OTP. Please try again.');
        setSnackbarOpen(true);
        logger.log(errorData.message || 'Invalid OTP. Please try again.', 'INFO');
        throw new Error(errorData.message || 'Invalid OTP. Please try again.');
      }

      const responseData = await response.json();
      logger.log(`OTP verified for registration: ${JSON.stringify(responseData)}`, 'INFO');
      setSuccessSnackbarMessage('Email verified successfully');
      setSuccessSnackbarOpen(true);
      setIsOtpVerified(true);
    } catch (error) {
      logger.log(`Error verifying OTP: ${error.message}`, 'ERROR');
      setSnackbarMessage(error.message || 'Invalid OTP. Please try again.');
      setSnackbarOpen(true);
    } finally {
      setIsVerifyingOtp(false);
    }
  };

  return (
    <div className="staff-mgmt-page">
      <Navbar />
      <div className="page">
        {loading ? (
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
            <CircularProgress />
            <Typography variant="h6" style={{ marginTop: '20px' }}>Fetching data...</Typography>
          </div>
        ) : (
          <div className="driver-table">
            <div className="header">
              <h2>Dispatchers</h2>
              <div className="moreActions">
                <div className="actual-search-wrapper">
                  <Form>
                    <InputGroup className='actual-search-wrapper-input border-0 shadow-none'>
                      <Form.Control
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder='Search...'
                      />
                    </InputGroup>
                  </Form>
                </div>

                <div className='newDD'>
                  <button className="staff-create-btn" onClick={handleOpen} data-tooltip-id="dispatcher-tooltip" aria-label="Create dispatcher">
                    <IoCreateOutline size={30} />
                  </button>
                  <Tooltip id="dispatcher-tooltip" place="bottom" content="Create Dispatcher" />
                </div>
              </div>
            </div>
            <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" closeAfterTransition slots={{ backdrop: Backdrop }} slotProps={{ backdrop: { timeout: 500, }, }} >
              <Fade in={open}>
                <Box sx={style}>
                  <div>
                    <p style={{ fontFamily: "sans-serif", fontSize: 24, fontWeight: 300, paddingBottom: '20px' }}>Add a new Dispatcher</p>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <TextField style={{ marginRight: 4.5 }} label="Name" value={newDispatcherDetails.name} onChange={(e) => handleInputChange('name', e.target.value)} />
                      <TextField style={{ marginLeft: 4.5 }} label="+91 Phone No." value={newDispatcherDetails.phone} onChange={(e) => handleInputChange('phone', e.target.value)} />
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <TextField label="Email" value={newDispatcherDetails.email} onChange={(e) => handleInputChange('email', e.target.value)} style={{ marginTop: 10, width: '80%' }} disabled={isOtpSent} />
                      {isSendingOtp && (
                        <div>
                          <CircularProgress size={40} style={{ marginTop: 20, marginRight: 20 }} />
                        </div>
                      )}
                      {!isSendingOtp && (
                        <Button onClick={handleSendAndStoreOTP} style={{ border: '1px solid rgba(0, 0, 0, 0.05)', borderRadius: 6, marginLeft: 8, marginTop: 10, color: isOtpSent ? "gray" : "white", backgroundColor: isOtpSent ? "#d3d3d3" : "#79c6e9", width: '100px', cursor: isOtpSent ? 'not-allowed' : 'pointer', paddingTop: '3px', paddingBottom: '3px' }} disabled={isOtpSent} >
                          Send OTP
                        </Button>
                      )}
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <TextField style={{ marginRight: 8, marginTop: 10, width: '80%' }} label="OTP" value={otp} onChange={(e) => setOtp(e.target.value)} disabled={isOtpVerified} />
                      <div>
                        {isVerifyingOtp && (
                          <div>
                            <CircularProgress size={40} style={{ marginTop: 20, marginRight: 20 }} />
                          </div>
                        )}
                        {!isVerifyingOtp && (
                          <Button onClick={handleVerifyOTP} style={{ border: '1px solid rgba(0, 0, 0, 0.05)', borderRadius: 6, marginTop: 10, color: isOtpVerified ? "gray" : "white", backgroundColor: isOtpVerified ? "#d3d3d3" : "#79c6e9", width: '95px', paddingBottom: '0px', cursor: isOtpVerified ? 'not-allowed' : 'pointer' }} disabled={isOtpVerified} >
                            Verify OTP
                          </Button>
                        )}
                      </div>
                    </div>
                    <TextField label="Temporary Password" type={showPassword ? 'text' : 'password'} value={newDispatcherDetails.password} onChange={(e) => handleInputChange('password', e.target.value)} style={{ marginTop: 10, width: '100%' }}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={handleTogglePasswordVisibility} aria-label="toggle password visibility" >
                              {showPassword ? <VisibilityOff /> : <Visibility />}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                    />
                    <TextField label="Note" multiline rows={4} value={newDispatcherDetails.notes} onChange={(e) => handleInputChange('notes', e.target.value)} style={{ marginTop: 10, width: '100%' }} />
                    <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 20 }}>
                      <Button onClick={handleResetForm} style={{ border: '1px solid rgba(0, 0, 0, 0.05)', borderRadius: 6, padding: 6, paddingLeft: 20, paddingRight: 20, color: "black", marginRight: 5 }}>Reset</Button>
                      <Button onClick={handleClose} style={{ border: '1px solid rgba(0, 0, 0, 0.05)', borderRadius: 6, padding: 6, paddingLeft: 20, paddingRight: 20, color: "black", marginRight: 5 }}>Cancel</Button>
                      <Button
                        onClick={handleSaveDispatcher}
                        style={{
                          border: '1px solid rgba(0, 0, 0, 0.05)',
                          borderRadius: 6,
                          padding: 6,
                          paddingLeft: 20,
                          paddingRight: 20,
                          color: !isOtpVerified ? "gray" : "white", backgroundColor: !isOtpVerified ? "#d3d3d3" : "#79c6e9", width: '95px', paddingBottom: '0px', cursor: !isOtpVerified ? 'not-allowed' : 'pointer'
                        }}
                        disabled={!isOtpVerified}
                      >
                        Save
                      </Button>

                    </div>
                  </div>
                </Box>
              </Fade>
            </Modal>

            <Modal
              open={view}
              onClose={handlehide}
              closeAfterTransition
              slots={{ backdrop: Backdrop }}
              slotProps={{
                backdrop: {
                  timeout: 500,
                },
              }}
            >
              <Fade in={view}>
                <Box sx={sstyle}>
                  {selectedDriver ? (
                    <>
                      <div style={{ textAlign: 'center' }}>
                        <div style={circularStyle}>
                          {selectedDriver.name.charAt(0).toUpperCase()}
                        </div>
                        <p style={{ fontSize: '24px' }}><b>{selectedDriver.name}</b></p>
                      </div>
                      <div style={{ flexGrow: 1, display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px' }}> {/* Gap creates space */}

                        <div>
                          <p><strong>Phone:</strong> {selectedDriver.phone}</p>
                          <p><strong>Note:</strong> {selectedDriver.notes || "No notes"}</p>
                        </div>

                        <div>
                          <p><strong>Email:</strong> {selectedDriver.email}</p>

                        </div>
                      </div>
                    </>
                  ) : (
                    <CircularProgress />
                  )}

                  <div style={{ display: 'flex', justifyContent: 'flex-center', marginLeft: '45%' }}>
                    <Button
                      onClick={handlehide}
                      style={{
                        backgroundColor: 'white',
                        color: 'black',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        padding: '6px 12px',
                      }}
                    >
                      Close
                    </Button>
                  </div>
                </Box>
              </Fade>
            </Modal>
            {/* Edit Modal */}
            <Dialog open={isEditModalOpen} onClose={() => setIsEditModalOpen(false)} maxWidth="sm" fullWidth PaperProps={{ style: { height: '80vh', width: '500px', overflowY: 'auto', }, }}>
              <DialogTitle>Edit Dispatcher</DialogTitle>
              <DialogContent>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                  <TextField
                    label="Name"
                    value={editDispatcherDetails?.name || ''}
                    onChange={(e) => handleEditInputChange('name', e.target.value)}
                    fullWidth
                    style={{ flex: 1, marginRight: '10px', marginTop: '10px' }}
                    error={editDispatcherDetails?.name?.trim() === ''}
                    helperText={editDispatcherDetails?.name?.trim() === '' ? "Name cannot be empty" : ""}
                    required
                  />
                  <TextField
                    label="+91 Phone No"
                    value={editDispatcherDetails?.phone || ''}
                    onChange={(e) => {
                      const phoneInput = e.target.value;

                      // Allow only numeric values and ensure length is no more than 10 digits
                      if (phoneInput.length <= 10 && /^[0-9]*$/.test(phoneInput)) {
                        handleEditInputChange('phone', phoneInput);
                      }
                    }}
                    fullWidth
                    style={{ flex: 1, marginTop: '10px' }}
                    error={editDispatcherDetails?.phone?.length !== 10}
                    helperText={editDispatcherDetails?.phone?.length !== 10 ? "Phone number must be 10 digits" : ""}
                  />
                </div>

                <TextField label="Email" value={editDispatcherDetails?.email || ''} onChange={(e) => handleEditInputChange('email', e.target.value)} fullWidth style={{ marginTop: '20px' }} disabled />
                <TextField label="Notes" value={editDispatcherDetails?.notes || ''} onChange={(e) => handleEditInputChange('notes', e.target.value)} fullWidth multiline rows={6} style={{ marginTop: '20px' }} />
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setIsEditModalOpen(false)} style={{ backgroundColor: 'white', color: 'black', border: '1px solid #ccc', borderRadius: '4px', padding: '6px 12px', }}>
                  Cancel
                </Button>
                <Button
                  onClick={handleSaveEdit}
                  style={{
                    backgroundColor: editDispatcherDetails?.name?.trim() === '' || editDispatcherDetails?.phone?.length !== 10
                      ? '#d3d3d3'
                      : '#79c6e9',
                    color: editDispatcherDetails?.name?.trim() === '' || editDispatcherDetails?.phone?.length !== 10
                      ? '#a1a1a1'
                      : 'black',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    padding: '6px 12px',
                    cursor: editDispatcherDetails?.name?.trim() === '' || editDispatcherDetails?.phone?.length !== 10
                      ? 'not-allowed'
                      : 'pointer',
                  }}
                  disabled={editDispatcherDetails?.name?.trim() === '' || editDispatcherDetails?.phone?.length !== 10}
                >
                  Save
                </Button>

              </DialogActions>
            </Dialog>

            {/* <div className="tabs">
              <button className={activeTab === 'driverList' ? 'active' : ''} onClick={() => setActiveTab('driverList')}>
                <strong>Dispatcher List</strong>
              </button>
            </div> */}

            {activeTab === 'driverList' && (
              <div>
                <div>
                  {dispatchers.length === 0 ? (
                    <div className="staff-empty-state">
                      <div className="center-content">
                        <div className="icon-wrapper">
                          <FaListUl className="icon" />
                        </div>
                        <span className="noOrdersMsg">No dispatchers found</span>
                      </div>
                    </div>
                  ) : (
                    <table className='DispatcherTable'>
                      <thead>
                        <tr>
                          <th className='Dth'><strong>Name</strong></th>
                          <th className='Dth'><strong>Phone</strong></th>
                          <th className='Dth'><strong>Email</strong></th>
                          <th className='Dth'><strong>Actions</strong></th>
                        </tr>
                      </thead>
                      <tbody>
                        {dispatchers.filter((driver) => {
                          return search.toLowerCase() === ''
                            ? driver
                            : driver.name.toLowerCase().includes(search.toLowerCase());
                        }).map((driver) => (
                          <tr key={driver._id} className="driver-active">
                            <td
                              onClick={() => handleViewClick(driver._id)}
                              className="clickable-name"
                            >
                              <span className="circular-initial">
                                {driver?.name?.charAt(0).toUpperCase()}
                              </span>
                              {driver.name}
                            </td>
                            <td className='Dtd'>{driver.phone}</td>
                            <td className='Dtd'>{driver.email}</td>

                            <td>
                              <button
                                className="three-dots"
                                onClick={(e) => handleThreeDotsClick(e, driver._id)}
                                aria-label={`Actions for ${driver.name}`}
                              >
                                <span>
                                  ...
                                </span>
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}

                </div>
              </div>
            )}

            <Menu
              anchorEl={anchorEl}
              open={Boolean(anchorEl)}
              onClose={handleCloseMenu}
              sx={{

                "& .MuiPaper-root": {
                  boxShadow: '1px 2px 2px 0px rgba(0, 0, 0, 0.1);',  // Light shadow
                  backgroundColor: '#fff',  // Background color
                  borderRadius: '8px',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  "&:hover": {
                    transform: 'scale(1.02)',
                    boxShadow: '0px 6px 18px rgba(0, 0, 0, 0.2)',
                  },
                },
                "& .MuiMenuItem-root": {
                  transition: 'background-color 0.3s ease, color 0.3s ease',  // Smooth transition for color changes
                  "&:hover": {
                    backgroundColor: '#f0f0f0',  // Light gray background on hover for menu items
                    color: '#79c6e9',  // Change text color on hover (optional)
                  },
                },
              }}
            >
              <MenuItem onClick={handleview}><FaEye style={{ marginRight: '8px' }} />  View Details</MenuItem>
              <MenuItem onClick={() => handleEdit(selectedDispatcherId)}><FaEdit style={{ marginRight: '8px' }} />  Edit</MenuItem>
              <MenuItem onClick={handleOpenDeleteDialog}> <FaTrashAlt style={{ marginRight: '8px' }} />  Delete</MenuItem>
            </Menu>



            <Dialog open={isDeleteDialogOpen} onClose={handleCloseDeleteDialog}>
              <DialogTitle>Delete Dispatcher</DialogTitle>
              <DialogContent>
                <DialogContentText>
                  Are you sure you want to delete this dispatcher?
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                <Button onClick={handleCloseDeleteDialog} style={{ backgroundColor: ' #79c6e9', color: 'black', border: '1px solid #ccc', borderRadius: '4px', padding: '6px 12px', }}>
                  Cancel
                </Button>
                <Button onClick={handleDeleteDispatcher} style={{ backgroundColor: 'white', color: 'black', border: '1px solid #ccc', borderRadius: '4px', padding: '6px 12px', }}>
                  Delete
                </Button>
              </DialogActions>
            </Dialog>

            <Drawer anchor="right" open={isDrawerOpen} onClose={handleDrawerClose}>

            </Drawer>
          </div>
        )}
      </div>
      <Snackbar open={snackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <Alert onClose={handleSnackbarClose} severity="error" sx={{ width: '100%', bgcolor: 'white', color: 'black', border: '2px solid red', boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.4)' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <Snackbar open={successSnackbarOpen} autoHideDuration={6000} onClose={handleSnackbarClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <Alert onClose={handleSnackbarClose} severity="success" sx={{ width: '100%', bgcolor: 'white', color: 'black', border: '2px solid green', boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.4)' }}>
          {successSnackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default Dispatcher;
